import { gql } from "../gql";
import "./fragments";

export const CUSTOMERS_QUERY = gql(`
  query Customers($salonId: ID!, $filters: CustomerFilterInput) {
    customers(salonId: $salonId, filters: $filters) {
      customers {
        ...CustomerDetail @unmask
      }
      pagination {
        ...Pagination @unmask
      }
    }
  }
`);

export const CUSTOMER_QUERY = gql(`
  query Customer($salonId: ID!, $customerId: ID!) {
    customer(salonId: $salonId, customerId: $customerId) {
      ...CustomerDetail @unmask
      pointRewards {
        ...PointReward @unmask
      }
      nonAppointmentRewards {
        ...PointReward @unmask
      }
    }
  }
`);

export const CREATE_CUSTOMER_MUTATION = gql(`
  mutation CreateCustomer($salonId: ID!, $input: CreateCustomerInput!) {
    createCustomer(salonId: $salonId, input: $input) {
      ...CustomerCore @unmask
      currentTier {
        id
        name
        color
      }
    }
  }
`);

export const UPDATE_CUSTOMER_MUTATION = gql(`
  mutation UpdateCustomer($salonId: ID!, $customerId: ID!, $input: UpdateCustomerInput!) {
    updateCustomer(salonId: $salonId, customerId: $customerId, input: $input) {
      id
      email
      firstName
      lastName
      phoneNumbers {
        id
        phone
        isPrimary
        isActive
        label
      }
      primaryPhone {
        id
        phone
        label
      }
      dateOfBirth
      notes
      updatedAt
    }
  }
`);

export const DELETE_CUSTOMER_MUTATION = gql(`
  mutation DeleteCustomer($salonId: ID!, $customerId: ID!) {
    deleteCustomer(salonId: $salonId, customerId: $customerId) {
      id
      isActive
    }
  }
`);

export const CHECK_CUSTOMER_EMAIL_EXISTS_QUERY = gql(`
  query CheckCustomerEmailExists($salonId: ID!, $email: String!) {
    checkCustomerEmailExists(salonId: $salonId, email: $email)
  }
`);

export const ADD_CUSTOMER_POINTS_MUTATION = gql(`
  mutation AddCustomerPoints($salonId: ID!, $customerId: ID!, $points: Float!, $description: String!) {
    addCustomerPoints(salonId: $salonId, customerId: $customerId, points: $points, description: $description) {
      id
      totalPoints
      currentTier {
        id
        name
        color
      }
    }
  }
`);

export const BULK_UPDATE_CUSTOMER_PHONES_MUTATION = gql(`
  mutation BulkUpdateCustomerPhones($salonId: ID!, $customerId: ID!, $input: BulkUpdateCustomerPhonesInput!) {
    bulkUpdateCustomerPhones(salonId: $salonId, customerId: $customerId, input: $input) {
      id
      phoneNumbers {
        id
        phone
        isPrimary
        isActive
        label
      }
      primaryPhone {
        id
        phone
        label
      }
    }
  }
`);
